import React, { useState } from 'react';

const RoundedCheckboxList = ({ proccessing_type = [], onChange }) => {
  const [selectedOptions, setSelectedOptions] = useState([]);

  const handleCheckboxChange = (item) => {
    let updatedSelection;
    if (selectedOptions.some((i) => i.processingType === item.processingType)) {
      updatedSelection = selectedOptions.filter(
        (i) => i.processingType !== item.processingType
      );
    } else {
      updatedSelection = [...selectedOptions, item];
    }

    setSelectedOptions(updatedSelection);
    onChange && onChange(updatedSelection);
  };

  // Calculate total fee
  const totalFee = selectedOptions.reduce(
    (sum, item) => sum + (item.processingFee || 0),
    0
  );

  return (
    <>
      <div className="row mt-2 processing-type-checkboxes">
        {proccessing_type.map((item, index) => {
          const isChecked = selectedOptions.some(
            (i) => i.processingType === item.processingType
          );
          return (
            <div className="col-md-6 col-sm-6 mb-2" key={index}>
              <div className="form-check">
                <input
                  className="form-check-input rounded-circle"
                  type="checkbox"
                  id={`checkbox-${index}`}
                  checked={isChecked}
                  onChange={() => handleCheckboxChange(item)}
                />
                <label
                  className="form-check-label ms-2"
                  htmlFor={`checkbox-${index}`}
                >
                  {item.processingType} <br/> <strong>LKR {item.processingFee}</strong>
                </label>
              </div>
            </div>
          );
        })}
      </div>

      <div className="d-flex mt-3">
        <div className="d-flex align-items-center">
          <span className="text-black2 fw-100 pt-2">Total Processing Fee:</span>
        </div>
        <div className="d-flex align-items-center">
          <h6 className="text-black2 fw-800 pt-2 ps-2">LKR {totalFee}</h6>
        </div>
      </div>
    </>
  );
};

export default RoundedCheckboxList;
